// Components
import PageTitle from "components/atoms/PageTitle";

// Hooks
import useTranslate from "hooks/useTranslate";
import { useBreakpoint } from "hooks/useBreakpoint";
import { useNavigate } from "react-router-dom";

// Images
import Map from "assets/images/banger/map.webp";
import AboutItem from "../AboutItem";

import "./styles.sass";

const GeneralInfo = () => {
  const t = useTranslate();
  const { isDesktop } = useBreakpoint();
  const navigate = useNavigate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const project = VITE_APP_PROJECT_NAME === "banger" ? "Banger" : "Glory";
  const about = t("info.about.desc");
  const title = t("info.navigation.about");
  const modifiedAbout =
    VITE_APP_PROJECT_NAME === "banger"
      ? about.replace("Glory", "Banger")
      : about;

  return (
    <div className="GeneralInfo">
      {isDesktop ? (
        <span className="GeneralInfo-header__name">{title}</span>
      ) : (
        <>
          <PageTitle
            title={t("footer.information")}
            onBack={() => navigate(-1)}
          />
          <span className="GeneralInfo__secondTitle">
            {t("info.navigation.about").toUpperCase()}
          </span>
        </>
      )}
      <div className="GeneralInfo-header">
        <div className="GeneralInfo-header-block">
          <div>
            <span className="GeneralInfo-header-block__project">
              {project} Casino -{" "}
            </span>
            <span className="GeneralInfo-header-block__title">
              {t("info.about.project")}
            </span>
          </div>
          <span className="GeneralInfo-header-block__second">
            {t("info.about.title")}
          </span>
        </div>
      </div>
      <div className="GeneralInfo-country">
        <div className="GeneralInfo-country__map">
          <img className="GeneralInfo-country__map_img" src={Map} alt="map" />
        </div>
        <div className="GeneralInfo-country__desc">{modifiedAbout}</div>
        <div className="GeneralInfo-country-info">
          <hr className="GeneralInfo-country__first" />
          <AboutItem
            className="GeneralInfo-country-info_first"
            name={`+ ${t("info.about.person.amount")}`}
            title="info.about.person.title"
            description="info.about.person.describe"
          />
          <hr className="GeneralInfo-country__second" />
          <AboutItem
            className="GeneralInfo-country-info_second"
            name="info.about.country.amount"
            title="info.about.country.title"
            description="info.about.country.describe"
          />
          <hr className="GeneralInfo-country__third" />
          <AboutItem
            className="GeneralInfo-country-info_third"
            name={`+ ${t("info.about.expert.amount")}`}
            title="info.about.expert.title"
            description="info.about.expert.describe"
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralInfo;
